module.exports = __webpack_public_path__ + "img/fg-bg.a904f0e7.png";